export const ManifestHeaders = {
  CaseReference: "CaseReference",
  TestRequired: "TestRequired",
  Name: "Name",
  Dob: "DOB",
  Gender: "Gender",
  Sample: "Sample",
  Notes: "NOTES"
}